module.exports = __webpack_public_path__ + "img/new_tool_omega.2510d515.png";